import {Stack, useTheme} from '@mui/material';
import {Loading as LoadingIcon} from 'presentation/components/Loading/Loading';

import {translations} from 'presentation/translations-new';
import React from 'react';

const {loading} = translations['pt-br'].commons;

export const Loading = () => {
	const {palette} = useTheme();

	return (
		<Stack
			sx={{
				backgroundColor: palette.primary.main,
				minHeight: '100vh',
				justifyContent: 'center',
				position: 'fixed',
				inset: 0,
				zIndex: 9999,
			}}>
			<LoadingIcon
				text={loading}
				textColor={palette.other.progressBar}
				minHeight="100%"
				sx={{color: palette.other.progressBar}}
				thickness={6}
			/>
		</Stack>
	);
};
